import {
  CentraStandalonePaymentButton,
  useCentraSelectionResponse,
} from "@made-people/grease-centra";

export const MMStandalonePaymentButtons = () => {
  const selection = useCentraSelectionResponse();
  if (!selection) {
    return null;
  }

  const paypalUri = selection.paymentMethods.find(
    (method) => method.paymentMethod === "paypal-commerce-button-new",
  )?.paymentMethod;

  const spiUri = selection.paymentMethods.find(
    (method) => method.paymentMethod === "spi",
  )?.paymentMethod;

  return (
    <>
      {paypalUri && <CentraStandalonePaymentButton paymentMethod={paypalUri} />}
      {spiUri && <CentraStandalonePaymentButton paymentMethod={spiUri} />}
    </>
  );
};
